import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row justify-content-md-end mb-2" }
const _hoisted_4 = { class: "row justify-content-between mb-2" }
const _hoisted_5 = { class: "col-md-4 col-8" }
const _hoisted_6 = { class: "row my-3" }
const _hoisted_7 = { class: "col container" }
const _hoisted_8 = { class: "row approval-table-header-row" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_ClearableInput = _resolveComponent("ClearableInput")!
  const _component_InvoiceApprovalListCell = _resolveComponent("InvoiceApprovalListCell")!
  const _component_BranchApprovalAffectedListDialog = _resolveComponent("BranchApprovalAffectedListDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumbs, {
        here: _ctx.pageTitle(),
        ancestries: _ctx.ancestries()
      }, null, 8, ["here", "ancestries"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "col h2",
          style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
        }, _toDisplayString(_ctx.pageTitle()), 5)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "col col-md-4 btn btn-info",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickApproveByBranch && _ctx.onClickApproveByBranch(...args)))
        }, "支店による承認処理")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ClearableInput, {
            text: _ctx.searchText,
            "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event))
          }, null, 8, ["text"])
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "month-select col-md-2 col-4 align-self-center",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.backwardMonthCountText) = $event))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("option", { value: "0" }, "今月", -1),
          _createElementVNode("option", { value: "1" }, "前月", -1)
        ]))], 512), [
          [_vModelSelect, _ctx.backwardMonthCountText]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"col-1\" data-v-57814442><span class=\"wrap-text\" data-v-57814442>社員ID</span></div><div class=\"col-2\" data-v-57814442><span class=\"wrap-text\" data-v-57814442>社員名</span></div><div class=\"col-6\" data-v-57814442><span class=\"wrap-text\" data-v-57814442>メッセージ</span></div>", 3)),
            _withDirectives(_createElementVNode("select", {
              class: "col-3 mx-n1",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedAcceptState) = $event))
            }, [
              _createElementVNode("option", {
                value: _ctx.acceptState.all
              }, "すべて表示", 8, _hoisted_9),
              _createElementVNode("option", {
                value: _ctx.acceptState.accept
              }, "承認済み", 8, _hoisted_10),
              _createElementVNode("option", {
                value: _ctx.acceptState.approvedByBranch
              }, "支店による承認済み", 8, _hoisted_11),
              _createElementVNode("option", {
                value: _ctx.acceptState.notAccept
              }, "未承認", 8, _hoisted_12)
            ], 512), [
              [_vModelSelect, _ctx.selectedAcceptState]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedApprovals, (apprv) => {
            return (_openBlock(), _createBlock(_component_InvoiceApprovalListCell, {
              key: apprv.vForKey,
              "invoice-approval": apprv,
              "is-for-branch-page": true
            }, null, 8, ["invoice-approval"]))
          }), 128)),
          (_ctx.searchedApprovals.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: "col empty-table-text align-self-center my-5",
                  style: _normalizeStyle({fontSize: _ctx.FontSizes.large1})
                }, "表示するデータは存在しません", 4)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_BranchApprovalAffectedListDialog, {
      show: _ctx.showAffectedListDialog,
      close: _ctx.closeAffectedListDialog,
      "branch-name": _ctx.branchName,
      "on-finish-approval": _ctx.onFinishApprovalByBranch
    }, null, 8, ["show", "close", "branch-name", "on-finish-approval"])
  ], 64))
}